<template>
	<div class="container">
		<section class="mobile_cs">
			<div class="sub_content1 d_flex justify_center align_items_center">
				<h2 class="title">
					{{ $t('cs.title') }}
				</h2>
			</div>
		</section>
		<div class="content cs">
			<p class="title">{{ $t('cs.notice') }}</p>
			<div class="cs_notice">
				<div v-if="noticeList.length > 0">
					<accordion v-for="item in noticeList" :key="item.seq" class="notice">
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p>{{ item.title }}</p>
								<div>
									<span class="date">{{
										$dayjs(item.regdate).format('YYYY.MM.DD')
									}}</span>
									<span class="accordion_trigger_icon"></span>
								</div>
							</template>
							<template v-slot:accordion-content>
								<div class="notice-accordion-content">
									<div v-html="item.content"></div>
								</div>
							</template>
						</accordion-item>
					</accordion>
				</div>
				<!-- 공지 없을때 -->
				<div class="notice_no" v-else>
					<p>{{ $t('cs.inquiry.no_content') }}</p>
				</div>
				<pagination
					:totalCount="pageNavigation.total_count"
					:totalPage="pageNavigation.total_page"
					:curPage="pageNavigation.cur_page"
					:point="pageNavigation.point"
					:firstPage="pageNavigation.first_page"
					:lastPage="pageNavigation.last_page"
					@change="pageChangeHandler"
				></pagination>
			</div>
		</div>
	</div>
</template>

<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import pagination from '@/components/Pagination';
import { fetchFaqList, fetchFaqTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Notice.m',
	components: {
		Accordion,
		AccordionItem,
		pagination,
	},
	data() {
		return {
			noticeList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	computed: {
		faqNotice() {
			return this.faqTypeList.find(item => {
				return item.name.toLowerCase() === 'notice';
			});
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},
		async loadFaqTypeList() {
			const { data } = await fetchFaqTypes().catch(commonError);
			this.faqTypeList = data;
		},
		async loadNoticeList() {
			const params = {
				type_seq: this.faqNotice.seq,
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.noticeList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadNoticeList();
		},
	},
};
</script>

<style scoped>
.m_notice .content {
	width: 100%;
	padding: 30px 16px;
	min-height: 300px;
}
section.mobile_cs .title {
	font-size: 30px;
	line-height: 1.2;
}
.mobile_cs .sub_content1 {
	width: 100%;
	min-height: 250px;
	margin: 0 auto;
	color: #fff;
	background-size: cover;
	background: #000 url('~@/assets/images/sub/cs.png') no-repeat 43% 0;
}
.cs.content .title {
	padding-bottom: 25px;
	font-size: 24px;
	line-height: 1.2;
	font-weight: bold;
	text-align: center;
}
.notice_no {
	border-bottom: 1px solid #ddd;
}
.notice_no p {
	padding: 50px 0;
	text-align: center;
	font-size: 14px;
}
</style>
